module.exports = __webpack_public_path__ + "media/images/incorrect-b014200ef18f4e5a3b0f4559d3e2c1b4.svg";